/*
 * @Author: dali
 * @Date: 2021-12-08 14:51:58
 * @LastEditors: dali
 * @LastEditTime: 2023-02-13 14:23:58
 * @FilePath: \gerlun-react-website\src\modules\baseModule.js
 * @Description:
 */
import axios from 'axios'
import { message } from 'antd'

function getQueryParams(query) {
  if (query) {
    const arr = []
    for (const q in query) {
      arr.push(q + '=' + query[q])
    }
    if (arr.length === 0) {
      return ''
    }
    return '?' + arr.join('&')
  }
}

class BaseModule {
  static _handleRequst({ url, query, method = 'GET', params = null, data = null, headers = {}, config = {}}) {
    return new Promise((resolve, reject) => {
      query && (url = url + getQueryParams(query))
      axios({
        method,
        url,
        params,
        data,
        headers,
        ...config
      }).then(res => {
        if (res.status === 200 && res.data) {
          if (res.data.status === 200 && res.data.ret) {
            resolve(res.data.data)
          } else if (res.data.status === 210) {
            resolve(res.data)
          } else if (res.data.status === 400) {
            message.error(res.data.msg)
            reject('error')
          } else {
            reject('error')
          }
        } else {
          reject('error')
        }
      }).catch(err => {
        reject(err)
      })
    })
  }

  get({ url, params = null, query, config = {}}) {
    return BaseModule._handleRequst({ url, method: 'GET', params, query, ...config })
  }

  post({ url, query, data = undefined, headers, config = {}}) {
    return BaseModule._handleRequst({ url, method: 'POST', data, query, headers, ...config })
  }

  put({ url, data = undefined, config = {}}) {
    return BaseModule._handleRequst({ url, method: 'PUT', data, ...config })
  }

  delete({ url, data = undefined, config = {}}) {
    return BaseModule._handleRequst({ url, method: 'DELETE', data, ...config })
  }
}

// 默认导出模块对象
export default BaseModule

